import 'react-toastify/dist/ReactToastify.css';

import './i18n';
import './initSettings';
import './themes/index.less';

import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import ProviderWrapper from './ProviderWrapper';

// TODO: TEMPORARY FIX - Remove this suppression once dependencies are React 19 compatible
// Suppresses "Accessing element.ref was removed in React 19" warnings from third-party libraries
// that haven't fully migrated to React 19 yet. This should be removed after verifying:
// - All dependencies in package.json support React 19
// - No React 19 ref warnings appear in console during testing
const originalConsoleError = console.error;
console.error = (...args: any[]) => {
  if (
    typeof args[0] === 'string' &&
    args[0].includes('Accessing element.ref was removed in React 19')
  ) {
    return; // Suppress React 19 ref warning
  }
  originalConsoleError.apply(console, args);
};
// import IntercomProviderWrapper from './components/IntercomProviderWrapper';
// const IntercomProviderWrapper = React.lazy(() => import('./components/IntercomProviderWrapper'));

export default function main(App: () => JSX.Element): void {
  const container = document.getElementById('root');

  if (container) {
    const root = createRoot(container);
    root.render(
      <div>
        <Suspense fallback="">
          {/* <IntercomProviderWrapper> */}
          <ProviderWrapper>
            <App />
          </ProviderWrapper>
          {/* </IntercomProviderWrapper> */}
        </Suspense>
      </div>,
    );
  }
}
